import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";

import AuthContext from "features/auth/AuthProvider";

import "./Navbar.css";

const NAV_ITEMS = [
  { path: "/clients", label: "Clients" },
  { path: "/projects", label: "Projects" },
  { path: "/services", label: "Services" },
  { path: "/checkslogs", label: "Checks Logs" },
  { path: "/notifications", label: "Notifications" },
  { path: "/changelog", label: "Changelog" },
];

const Navbar = () => {
  const { pathname } = useLocation();
  const { setToken } = React.useContext(AuthContext);

  // Prefix match, so a detail route like /services/42 keeps Services lit.
  const isActive = (path) =>
    pathname === path || pathname.startsWith(`${path}/`);

  const handleLogout = () => {
    setToken("");
  };

  return (
    <nav className="navbar">
      <div className="title">
        <Link to="/">Rorschach?</Link>
      </div>
      <ul>
        {NAV_ITEMS.map(({ path, label }) => (
          <li key={path} className={isActive(path) ? "selected" : ""}>
            <Link to={path} aria-current={isActive(path) ? "page" : undefined}>
              {label}
            </Link>
          </li>
        ))}
        <li>
          <button className="logout" onClick={handleLogout} aria-label="Logout">
            <LogoutIcon />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
